// extracted by mini-css-extract-plugin
export var editButton = "_qu-0";